import { render, staticRenderFns } from "./calendar-configuration.view.vue?vue&type=template&id=582f137a&scoped=true&"
import script from "./calendar-configuration.view.vue?vue&type=script&lang=ts&"
export * from "./calendar-configuration.view.vue?vue&type=script&lang=ts&"
import style0 from "./calendar-configuration.view.vue?vue&type=style&index=0&id=582f137a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "582f137a",
  null
  
)

export default component.exports